import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, notify } from '@speeki/global-ui-components';

import { SuccessTemplate } from '@components/templates/SuccessTemplate/SuccessTemplate';

import { useGetServiceRedirect } from '@utils/hooks/useServiceRedirect';

import { getPath } from '@services/RouteService/paths';

import { forceDefaultNavigationVar } from '@boot/reactiveVariables';

import { ReturnButtonWrapper } from './SuccessfulMfaSetupPage.styled';

export const SuccessfulMfaSetupPage = () => {
    const { t } = useTranslation();

    const navigate = useNavigate();

    const serviceRedirect = useGetServiceRedirect();

    useEffect(() => {
        forceDefaultNavigationVar(true);

        return () => {
            forceDefaultNavigationVar(false);
        };
    }, []);

    return (
        <SuccessTemplate
            texts={[t('SUCCESSFUL_MFA_SETUP_TEXT')]}
            title={t('SUCCESSFULL_MFA_SETUP_TITLE')}
        >
            <ReturnButtonWrapper>
                <Button
                    center
                    onClick={() => {
                        navigate(
                            getPath({
                                params: serviceRedirect.params,
                                path: serviceRedirect.path,
                            }),
                        );
                        notify(t('SUCCESSFUL_MFA_SETUP_CONFIRM')).SUCCESS();
                    }}
                    testId="button_continue"
                    variant="primary"
                >
                    {t('CONTINUE')}
                </Button>
            </ReturnButtonWrapper>
        </SuccessTemplate>
    );
};
